import { api } from '@/api/client'
import { toast } from '@crosscode/gravity-components'
import type { RemoteConnection } from '@/features/remote/types'
import { DEFAULT_TUNNEL_URL } from '@/features/remote/types'

export async function fetchNodeRdp(nodeId: string | number): Promise<RemoteConnection | null> {
  try {
    const data = await api<RemoteConnection>(`/api/nodes/${nodeId}/remote-access`)
    if (!data?.connectionToken && !data?.url) {
      toast.error('RDP-подключение не найдено')
      return null
    }
    return {
      ...data,
      tunnelUrl: data.tunnelUrl || DEFAULT_TUNNEL_URL,
      label: data.label || 'RDP',
    }
  } catch (err) {
    toast.error(err instanceof Error ? err.message : 'Ошибка RDP')
    return null
  }
}
